import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { QuickScoringButton } from '../credit/QuickScoringButton';
import { useStore } from '../../contexts/StoreContext';
const nav = [{
  to: '/catalogo',
  label: 'Catálogo 0 km'
}, {
  to: '/marcas',
  label: 'Marcas'
}, {
  to: '/simulador',
  label: 'Simulador'
}, {
  to: '/comparar',
  label: 'Comparar'
}];
export function Header() {
  const {
    compareIds
  } = useStore();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setOpen(false), [location.pathname]);
  const linkClass = ({
    isActive
  }: {
    isActive: boolean;
  }) => `relative whitespace-nowrap rounded-lg px-3 py-2 text-sm font-bold uppercase tracking-wide text-white transition-colors duration-150 ${isActive ? 'bg-neon/15 shadow-[inset_0_-2px_0_#4D8CFF]' : 'hover:bg-white/10'}`;
  return <header className="sticky top-0 z-40 border-b border-silver-dark/20 bg-ink/85 backdrop-blur-md" data-id="element-952" data-mp="6v5gvbexjz5m">
      <div className="container-x flex h-16 items-center justify-between gap-4" data-id="element-953" data-mp="bt6xzqsspoeg">
        <div className="flex shrink-0 items-center gap-3" data-id="element-954" data-mp="gmjbb4s0y8rw">
          <Link to="/" aria-label="VCARS — Inicio" className="rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neon" data-id="element-955" data-mp="lkl2kczlteeg">
            <Logo showTagline={false} data-id="element-956" data-mp="3k3i7uecnjpn9" />
          </Link>
          <NavLink to="/" end className={({
          isActive
        }) => `btn h-9 rounded-lg px-4 text-xs font-black tracking-[0.2em] ${isActive ? 'btn-primary' : 'border border-neon/60 text-white hover:bg-neon/15'}`} data-id="element-957" data-mp="3p11mvgh6c6g9">
            HOME
          </NavLink>
        </div>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="Principal" data-id="element-958" data-mp="19943g7gbqowi">
          {nav.map(n => <NavLink key={n.to} to={n.to} className={linkClass} data-id="element-959" data-mp="1da62an6bwyxy">
              {n.label}
              {n.to === '/comparar' && compareIds.length > 0 && <span className="ml-1.5 rounded-full bg-neon px-1.5 py-0.5 text-[10px] font-bold text-white" data-id="element-960" data-mp="35dtmb3ugc806">{compareIds.length}</span>}
            </NavLink>)}
        </nav>

        <div className="hidden items-center gap-2 lg:flex" data-id="element-961" data-mp="3ee8cohm9wdaj">
          <Link to="/chequeo" className="btn btn-credit h-10" data-id="element-962" data-mp="3ebvuc3cls0wy">
            Chequeo crediticio
          </Link>
          <QuickScoringButton className="btn btn-metal h-10 px-4" data-id="element-963" data-mp="2qm1hvmw74ed8" />
        </div>

        <button className="rounded-lg p-2 text-white hover:bg-white/5 lg:hidden" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} data-id="element-964" data-mp="2mona7zo5yenc">
          {open ? <XIcon className="h-6 w-6" data-id="element-965" data-mp="27wlduplay3s2" /> : <MenuIcon className="h-6 w-6" data-id="element-966" data-mp="27vjsnsako0wm" />}
        </button>
      </div>

      <AnimatePresence data-id="element-967" data-mp="22ya6clihc5d0">
        {open && <motion.nav id="mobile-nav" aria-label="Menú móvil" className="border-t border-line bg-ink lg:hidden" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-968" data-mp="igsk72655qg9">
            <div className="container-x flex flex-col py-3" data-id="element-969" data-mp="efpa6waryomy">
              {nav.map(n => <NavLink key={n.to} to={n.to} className={({
            isActive
          }) => `flex items-center justify-between rounded-lg px-3 py-3 text-base font-bold uppercase tracking-wide text-white ${isActive ? 'bg-neon/15' : ''}`} data-id="element-970" data-mp="1259qt8jgh9t2">
                  {n.label}
                  {n.to === '/comparar' && compareIds.length > 0 && <span className="rounded-full bg-neon px-2 py-0.5 text-xs font-bold text-white" data-id="element-971" data-mp="3cv89lffya8jk">{compareIds.length}</span>}
                </NavLink>)}
              <Link to="/chequeo" className="btn btn-credit mt-3 w-full" data-id="element-972" data-mp="116rye0ceehk">
                Chequeo crediticio
              </Link>
              <QuickScoringButton className="btn btn-metal mt-2 w-full" data-id="element-973" data-mp="3sdja6x35ebl5" />
            </div>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}